module.exports = __webpack_public_path__ + "static/media/VICTORY3.353f6b2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/VICTORY3.mp3
// module id = 303
// module chunks = 1 2 3